export default class EsriLoad {
    public map;
    public baseMap;
    public mapView;
    public graphic;
    public graphicsLayer;
    public featureLayer;
    public tileLayer;
    public imageryLayer;
    public unknownLayer;
    public mapImageLayer;
    public layerList;
    public sceneView;
    public editor;
    public expand;
    public urlUtils;
    public identityManager;
    public spatialReference;
    public wmslayer;

    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.map) {
            this.map = model.map;
        }
        if (model.mapView) {
            this.mapView = model.mapView;
        }
        if (model.graphic) {
            this.graphic = model.graphic;
        }
        if (model.graphicsLayer) {
            this.graphicsLayer = model.graphicsLayer;
          }
          if (model.featureLayer) {
            this.featureLayer = model.featureLayer;
          }
          if (model.tileLayer) {
            this.tileLayer = model.tileLayer;
          }
          if (model.imageryLayer) {
            this.imageryLayer = model.imageryLayer;
          }
          if (model.unknownLayer) {
            this.unknownLayer = model.unknownLayer;
          }
          if (model.mapImageLayer) {
            this.mapImageLayer = model.mapImageLayer;
        }
        if (model.layerList) {
            this.layerList = model.layerList;
        }
        if (model.sceneView) {
            this.sceneView = model.sceneView;
        }
        if (model.expand) {
            this.expand = model.expand;
        }
        if (model.editor) {
            this.editor = model.editor;
        }
        if (model.urlUtils) {
            this.urlUtils = model.urlUtils;
        }
        if (model.identityManager) {
            this.identityManager = model.identityManager;
        }
        if (model.wmslayer) {
            this.wmslayer = model.wmslayer;
        }
    }
}
